import { useUiKitComponents } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { NavigationItem } from "../Header";

export type NavbarDropdownMenuProps = {
  data: Array<{
    id?: ID;
    title?: string;
    dropdownMenuPages: Array<NavigationItem>;
  }>;
  navigationName: string;
  playerId?: string | null;
  clickHeaderSub: (targetUrl: string) => void;
};

export const NavbarDropdownMenu: FC<NavbarDropdownMenuProps> = ({
  data,
  clickHeaderSub,
}) => {
  const { Link } = useUiKitComponents();

  return (
    <div className="navbar-menu" data-testid="header-navbar-menu">
      <div className="navbar-menu-content">
        {data?.map((dropdown) => (
          <div className="navbar-menu-dropdown" key={dropdown.id}>
            {dropdown?.title && (
              <h5 className="navbar-menu-title">{dropdown?.title}</h5>
            )}
            {dropdown.dropdownMenuPages?.map((subpage, idx) => (
              <Link
                href={subpage.url}
                className="navbar-menu-subpage cursor-pointer"
                key={subpage.id}
                onClick={() => clickHeaderSub(subpage.url)}
                data-testid={`header-navbar-menu-item-${idx}`}
              >
                <img
                  src={subpage?.imageUrl}
                  alt={subpage.imageAlternativeText ?? ""}
                />
                <span className="navbar-menu-subpage-title base-body2-text">
                  {subpage.title}
                </span>
              </Link>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
